export let SupportCategory = {
  categoryId: '',
  categoryName: ''
}

export let Support = {
  supportId: '',
  categoryId: '',
  categoryName: '',
  subject: '',
  status: '',
  createdAt: '',
  updatedAt: ''
}

export let SupportAttachment = {
  attachmentId: '',
  orgFileName: '',
  fileName: '',
  fileSizeByte: 0
}

export let SupportCommunication = {
  communicationId: '',
  userName: '',
  userType: 0,
  createdAt: '',
  updatedAt: '',
  body: '',
  attachments: []
}

export let SupportDetail = Object.assign({communications: []}, Support)

export const SupportStatus = {
  WAITING: 'WAITING',
  PROCESSING: 'PROCESSING',
  ANSWERED: 'ANSWERED',
  RESOLVED: 'RESOLVED',
  CANCELED: 'CANCELED'
}

export const SupportUserType = {
  USER: 1,
  SUPPORT: 2
}



// WEBPACK FOOTER //
// ./src/defines/support.js